/*
  NordicVend: den fasta köpradens skript (snippets/STICKY-ATC.liquid).
  Låg tidigare inline i snippeten. Som egen fil cachas den mellan sidvisningar.
  Laddas med defer från snippeten. Värden från Liquid läses från skripttaggens
  data-attribut (document.currentScript), så filen innehåller ingen Liquid.
*/
(function () {
  var bar = document.getElementById('satc-bar');
  if (!bar) return;

  var priceEl = bar.querySelector('[data-satc-price]');
  var saveEl  = bar.querySelector('[data-satc-save]');
  var saveAmt = bar.querySelector('[data-satc-save-amount]');
  var vatEl   = bar.querySelector('[data-satc-vat]');
  var imgEl   = bar.querySelector('.satc-product-img');
  var variantEl = bar.querySelector('[data-satc-variant]');

  /* ---- Vald variant ----
     Raden följer händelsen nv:variant från variantvakten i CUSTOM-PRICE.
     Vid start läses vakten (eller ?variant= i adressen) en gång. Ingen timer. */
  var variants = {};
  try { variants = JSON.parse(document.currentScript.getAttribute('data-varianter') || '{}'); } catch (e) {}
  // Variantvakten i CUSTOM-PRICE har samma data (pris, jämförpris, lager, namn).
  // Finns den används den, annars datan från skripttaggen (prisblocket kan saknas).
  (function () {
    var w = window.__nvVariantWatch;
    if (!w || !w.variants) return;
    Object.keys(w.variants).forEach(function (id) {
      var x = w.variants[id];
      variants[id] = {
        available: !!x.available,
        title: x.title,
        price: x.price,
        compare: x.compare_at_price || 0
      };
    });
  })();
  var currentId = String(bar.getAttribute('data-variant-id') || '');
  var available = !!(variants[currentId] && variants[currentId].available);

  function urlVariantId() {
    var id = new URLSearchParams(window.location.search).get('variant');
    return id && variants[id] ? id : '';
  }
  function renderVariantTitle() {
    if (!variantEl) return;
    var info = variants[currentId];
    var title = info && info.title && info.title !== 'Default Title' ? info.title : '';
    variantEl.textContent = title;
    variantEl.hidden = !title;
  }
  function setVariant(id, availableHint) {
    id = String(id || '');
    if (!id) return;
    currentId = id;
    if (variants[id]) {
      available = !!variants[id].available;
    } else if (typeof availableHint === 'boolean') {
      available = availableHint;
    }
    bar.setAttribute('data-variant-id', id);
    renderVariantTitle();
  }
  // Har nv:variant kommit (eller finns vakten) gäller den varianten, adressen
  // kan vara gammal (temaredigeraren, eller en kombination som inte finns)
  var fromEvent = false;
  function watchedId() {
    var w = window.__nvVariantWatch;
    var id = w && w.current && w.current.id ? String(w.current.id) : '';
    return id && variants[id] ? id : '';
  }
  var startId = watchedId();
  if (startId) {
    fromEvent = true;
  } else {
    startId = urlVariantId();
  }
  if (startId) setVariant(startId);
  renderVariantTitle();

  /* ---- Pris: samma formatering och samma momsläge som produktsidan ---- */
  /* Prisformatet finns på ett ställe: window.NVMoney (NV-OFFERT-CORE, i head) */
  function fmt(cents) { return window.NVMoney.format(cents); }
  // Gemensamt momsläge för hela butiken (NV-MOMS)
  function currentMode() {
    return window.NVMoms && window.NVMoms.get() === 'inkl' ? 'inkl' : 'exkl';
  }
  function amount(inklCents, mode) {
    inklCents = parseInt(inklCents, 10) || 0;
    return mode === 'inkl' ? inklCents : Math.round(inklCents * 0.8);
  }
  function renderPrices() {
    var mode = currentMode();
    if (priceEl) priceEl.textContent = fmt(amount(priceEl.dataset.inkl, mode));
    if (saveAmt) saveAmt.textContent = fmt(amount(saveAmt.dataset.inkl, mode));
    // Etiketten (vatEl) visas via klassen på <html>, se NV-MOMS
  }
  // Pris och rabatt ur variantdatan ovan
  function applyInfoPrices(id) {
    var info = variants[id];
    if (!info) return;
    var onSale = info.compare > info.price;
    if (priceEl) priceEl.dataset.inkl = info.price;
    if (saveAmt) saveAmt.dataset.inkl = onSale ? (info.compare - info.price) : 0;
    if (saveEl) saveEl.hidden = !onSale;
  }
  if (startId) applyInfoPrices(startId);
  renderPrices();

  // Momsreglaget (produktsidan eller menyn), NV-MOMS skickar nv:price-mode
  document.addEventListener('nv:price-mode', renderPrices);

  // Ny variant vald: pris, rabatt, bild och om den går att köpa
  document.addEventListener('nv:variant', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    if (v.id) {
      setVariant(v.id, v.available !== false);
      fromEvent = true;
    }
    if (priceEl) priceEl.dataset.inkl = v.price;
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (saveAmt) saveAmt.dataset.inkl = onSale ? (v.compare_at_price - v.price) : 0;
    if (saveEl) saveEl.hidden = !onSale;
    var src = v.featured_image && (v.featured_image.src || v.featured_image);
    if (imgEl && typeof src === 'string' && src) {
      imgEl.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=80&height=80&crop=center';
    }
    renderPrices();
    onScroll();
  });

  // Reserv när variantvakten saknas: bakåt och framåt i webbläsaren
  window.addEventListener('popstate', function () {
    if (window.__nvVariantWatch) return;
    var id = urlVariantId();
    if (!id || id === currentId) return;
    setVariant(id);
    applyInfoPrices(id);
    renderPrices();
    onScroll();
  });

  /* ---- Visas när sidans egen "Lägg i varukorg"-knapp inte syns ----
     Både innan man scrollat ner till knappen och efter att man scrollat förbi
     den. Döljs när knappen syns på skärmen. Är varianten slutsåld visas den inte. */
  var FALLBACK_THRESHOLD = 600;
  function getAnchor() {
    var btn = document.getElementById('nv-atc-btn');
    if (btn && btn.offsetParent !== null) return btn;
    var form = document.querySelector('form[action^="/cart/add"]');
    if (form && form.offsetParent !== null) return form;
    return null;
  }
  var headerEl = document.querySelector('[data-site-header]');
  function headerState() {
    return window.NVHeader ? window.NVHeader.state() : 'static';
  }
  function headerOffset() {
    var st = headerState();
    if (st === 'shown') return window.NVHeader.offset();
    if (st === 'hidden') return 0;
    if (headerEl) return Math.max(0, headerEl.getBoundingClientRect().bottom);
    return window.NVHeader ? window.NVHeader.offset() : 0;
  }
  function anchorOutOfView(topOffset) {
    var anchor = getAnchor();
    if (!anchor) return window.scrollY >= FALLBACK_THRESHOLD;
    var r = anchor.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom <= topOffset || r.top >= vh;
  }
  function setBarState(visible) {
    bar.classList.toggle('satc-visible', visible);
    if (visible) {
      bar.setAttribute('aria-hidden', 'false');
      bar.removeAttribute('inert');
    } else {
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
    }
  }
  var ticking = false;
  var lastTop = -1;
  var lastH = -1;
  var mobileMq = window.matchMedia('(max-width: 999px)');

  // Köpradens höjd, så att Chatway-bubblan kan läggas precis ovanför den på mobil.
  // Följs med ResizeObserver, så att apply() inte behöver mäta varje bildruta.
  function setHeight(h) {
    h = Math.round(h);
    if (h === lastH) return;
    lastH = h;
    document.documentElement.style.setProperty('--satc-h', h + 'px');
  }
  var heightObserved = false;
  if ('ResizeObserver' in window) {
    heightObserved = true;
    new ResizeObserver(function (entries) {
      var e = entries[entries.length - 1];
      var box = e.borderBoxSize && (e.borderBoxSize[0] || e.borderBoxSize);
      setHeight(box && box.blockSize ? box.blockSize : bar.offsetHeight);
    }).observe(bar);
  }

  // Först läses allt (header, köpknappens läge, höjd), sedan skrivs allt,
  // så att webbläsaren bara behöver räkna om layouten en gång per bildruta.
  function apply() {
    ticking = false;
    // Mobil: raden ligger i botten, så headern påverkar inte var den hamnar.
    // På dator kan raden gå in några px under headerns underkant: det syns inte,
    // men tar bort varje glapp från avrundning, kantlinjer och animationer.
    var OVERLAP = 4;
    var mobile = mobileMq.matches;
    var state = headerState();
    var off = mobile ? 0 : headerOffset();
    var top = off > 0 ? Math.max(0, Math.floor(off) - OVERLAP) : 0;
    var visible = available && anchorOutOfView(mobile ? Math.round(headerOffset()) : top);
    var h = heightObserved ? lastH : bar.offsetHeight;

    bar.classList.toggle('satc-anim', !mobile && state !== 'static');
    if (top !== lastTop) {
      bar.style.setProperty('--satc-top', top + 'px');
      lastTop = top;
    }
    setBarState(visible);
    if (!heightObserved) setHeight(h);
    document.body.classList.toggle('satc-bottom-visible', mobile && visible);
    // Dator: headern och köpraden ska se ut som en enda list, utan skuggkant emellan
    document.documentElement.classList.toggle('satc-top-visible', !mobile && visible);
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // Headern glider in eller ut: följ med mjukt i stället för att hoppa
  document.addEventListener('nv:header', apply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onScroll);
  } else {
    onScroll();
  }
  window.addEventListener('load', onScroll);

  /* ATC */
  var btn = bar.querySelector('.js-satc-trigger');
  if (!btn) return;
  // Produktsidans eget formulär (det med sidans köpknapp), inte första bästa
  // /cart/add-formulär på sidan, som kan tillhöra en annan produkt.
  function getProductForm() {
    var mainBtn = document.getElementById('nv-atc-btn');
    var form = mainBtn ? mainBtn.closest('form') : null;
    return form || document.querySelector('form[data-product-form]') || document.querySelector('form[action^="/cart/add"]');
  }
  // Skriver in vald variant i formulärets id-fält, så att det alltid är den
  // variant som visas i raden som läggs till.
  function syncIdField(form, id) {
    var field = form.querySelector('[name="id"]');
    if (!field) return false;
    if (field.tagName === 'SELECT') {
      var found = false;
      for (var i = 0; i < field.options.length; i++) {
        if (field.options[i].value === id) {
          field.selectedIndex = i;
          found = true;
          break;
        }
      }
      return found;
    }
    field.value = id;
    return true;
  }
  /* Dubbeltryck: knappen är upptagen (aria-busy) tills varukorgslådan
     meddelar att tillägget är klart (nv:cart-add), eller högst 4 sekunder.
     Knappen görs inte disabled, så att fokus ligger kvar på den. */
  var busy = false;
  var busyTimer = null;
  function setBusy(on) {
    busy = on;
    clearTimeout(busyTimer);
    busyTimer = null;
    if (on) {
      btn.setAttribute('aria-busy', 'true');
      busyTimer = setTimeout(function () { setBusy(false); }, 4000);
    } else {
      btn.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('nv:cart-add', function () {
    if (busy) setBusy(false);
  });

  btn.addEventListener('click', function (e) {
    if (busy || btn.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    var form = getProductForm();
    if (!form) return;
    var id = fromEvent ? currentId : (urlVariantId() || currentId);
    if (id !== currentId) setVariant(id);
    if (!available || !variants[id] || !variants[id].available) {
      onScroll();
      return;
    }
    if (!syncIdField(form, id)) return;
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (qtyInput) qtyInput.value = 1;
    var candidates = form.querySelectorAll('button[type="submit"], input[type="submit"]');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].classList.contains('satc-btn')) continue;
      // Sidans knapp är upptagen med ett tidigare tillägg: gör inget
      if (candidates[i].disabled) break;
      setBusy(true);
      candidates[i].click();
      break;
    }
  });
})();
